module.exports = {
    config: {
        transitionTime: 200, //ms
        AJAX_URL_PREFIX: 'fp-ajax-for-mobile-theme',
        numberOfAttemptsToLoadPage: 10,
        adLoadDelay: 500,
        headerHeight: 76,
        lazyLoadTimeout: 10,
        lazyLoadPreloadNScreens: 2,
        limitCriteoForInFeed: false
    },
    events: {},
    createEvents: function (types) {
        types.forEach(type => {
            this.events[type] = document.createEvent('Event');
            this.events[type].initEvent(type, true, true);
        });
    },
    getEventByName: function (name) {
        return this.events[name];
    },
    addEvent: function (object, type, callback) {
        if (object == null || typeof(object) == 'undefined') return;
        if (object.addEventListener) {
            object.addEventListener(type, callback, false);
        } else if (object.attachEvent) {
            object.attachEvent("on" + type, callback);
        } else {
            object["on" + type] = callback;
        }
    },
    attachEventToLinks: function (nodes, callback) {
        for (let i = 0; i < nodes.length; i++) {
            let link = nodes[i];
            this.addEvent(link, 'click', callback);
        }
    },
    isExternalUrl: function (url) {
        var domain = function (url) {
            return url.replace('http://', '').replace('https://', '').split('/')[0];
        };

        return domain(location.href) !== domain(url);
    },
    findParentByClassName: function (elem, className) {
        while (elem.parentNode) {
            elem = elem.parentNode;
            if (new RegExp(className).test(elem.className)) return elem;
        }
        return null;

    },
    toggleMenuBtn: function (elem) {
        if (elem.dataset.state === 'closed') {
            elem.setAttribute('data-state', 'opened');
        } else if (elem.dataset.state === 'opened') {
            elem.setAttribute('data-state', 'closed');
        }
    },
    closeMenuBtn: function (elem) {
        elem.setAttribute('data-state', 'closed');
    },
    closeSidebar: function () {
        document.querySelector('#sidebar').removeAttribute('open');
        let mask = document.querySelector('.-amp-sidebar-mask') || document.querySelector('.i-amphtml-sidebar-mask');
        if (mask) mask.style.display = 'none';
    },
    ajax: function (url, success, error) {
        var xhr = new XMLHttpRequest();
        xhr.open('GET', url);
        xhr.onload = function () {
            if (xhr.status === 200) {
                success(xhr.responseText);
            }
            else {
                if (error !== undefined) error(xhr.status);
            }
        };
        xhr.onerror = function () {
            if (error !== undefined) error(xhr.status);
        };
        xhr.send();
    },
    getContent: function (url, callback, options) {

        //add 'fp-ajax-for-mobile-theme' to URL
        let ajaxUrl = this.addStrToUrl(url, this.config.AJAX_URL_PREFIX);
        options = options || {};
        options.url = url;
        let that = this;
        let callCounter = 0;

        function call(ajaxUrl) {
            that.ajax(ajaxUrl, (content) => {
                var holder = document.createElement('div');
                holder.innerHTML = content;
                var result = {};
                var mainCol = holder.querySelector('#slider .main-col');
                result.slide = mainCol.innerHTML;
                result.prev = mainCol.dataset.prevUrl;
                result.next = mainCol.dataset.nextUrl;
                result.type = mainCol.dataset.type;
                result.title = holder.querySelector('title').innerHTML;
                callback(result, options);
            }, (err) => {
                console.log('Network error occurred, url failed is ' + ajaxUrl + ' Code is ' + err);
                setTimeout(() => {
                    if (callCounter >= that.config.numberOfAttemptsToLoadPage) {
                        callback({slide: that.errorHtmlCode, title: "-"}, options);
                        return;
                    }
                    call(ajaxUrl);
                    callCounter++
                }, 1000);
            });
        }

        call(ajaxUrl);

    },
    addStrToUrl: function (url, str) {
        let link = document.createElement("a");
        link.href = url;
        let path = link.pathname;
        let needle = link.protocol + "//" + link.host + link.pathname;
        let replace = link.protocol + "//" + link.host + "/" + str + link.pathname;
        return url.replace(needle, replace);
    },
    historyApiSupport: !!(window.history && history.pushState),
    killContent: function (parent, callback) {
        for (let i = 0; i < parent.children.length; i++) {
            let node = parent.children[i];
            node.style.opacity = 1;
            node.style.transition = 'opacity ' + this.config.transitionTime + 'ms linear';
            node.style.opacity = 0;
        }
        setTimeout(() => {
            parent.innerHTML = '';
            callback();
        }, this.config.transitionTime);
    },
    loaderHtml: '<div class="loader visible"></div>',
    removeClass: function (node, value) {
        let regex = new RegExp("^" + value + "$|^" + value + " | " + value + "$| " + value + " ", "g");
        let newClassName = node.className;

        newClassName = newClassName.replace(regex, ' ');
        newClassName = newClassName.replace(/  /g, ' ');
        newClassName = newClassName.replace(/^ | $/g, '');

        node.className = newClassName;
    },
    addClass: function (node, value) {
        let regex = new RegExp(value);
        if (!regex.test(node.className)) {
            node.className = node.className + ' ' + value;
        }
    },
    setPageTitleAndSendGAEvent: function (title) {
        //set title
        if (title) window.document.title = title;

        //set GA event
        window.ga('set', 'page', window.location.pathname);
        window.ga('send', 'pageview');

        //update addThis
        this.updateAddThis(title);
    },
    shorter_number_js: function (num) {
        var o = '';
        if (num < 1000) {
            o = num;
        } else if (num >= 1000 && num < 10000) {
            o = this.round(num / 1000, 1) + "k";
        } else if (num >= 10000 && num < 1000000) {
            o = this.round(num / 1000, 0) + "k";
        } else if (num >= 1000000 && num < 10000000) {
            o = this.round(num / 1000000, 1) + "M";
        } else if (num >= 10000000) {
            o = this.round(num / 1000000, 0) + "M";
        }
        return o;
    },
    round: function (value, precision, mode) {
        //  discuss at: http://locutus.io/php/round/
        // original by: Philip Peterson
        var m, f, isHalf, sgn; // helper variables
        // making sure precision is integer
        precision |= 0;
        m = Math.pow(10, precision);
        value *= m;
        // sign of the number
        sgn = (value > 0) | -(value < 0);
        isHalf = value % 1 === 0.5 * sgn;
        f = Math.floor(value);
        if (isHalf) {
            switch (mode) {
                case 'PHP_ROUND_HALF_DOWN':
                    // rounds .5 toward zero
                    value = f + (sgn < 0);
                    break;
                case 'PHP_ROUND_HALF_EVEN':
                    // rouds .5 towards the next even integer
                    value = f + (f % 2 * sgn);
                    break;
                case 'PHP_ROUND_HALF_ODD':
                    // rounds .5 towards the next odd integer
                    value = f + !(f % 2);
                    break;
                default:
                    // rounds .5 away from zero
                    value = f + (sgn > 0)
            }
        }
        return (isHalf ? value : Math.round(value)) / m
    },
    updateShareCounter: function (elements) {
        if (!elements || elements.length === 0) return;

        let url = elements[0].dataset.currentUrlEncoded;
        let min_value = elements[0].dataset.postTitle.length / 2;

        min_value = Math.round(min_value);

        this.ajax('http://graph.facebook.com/?id=' + url, dataStr => {
            let data = JSON.parse(dataStr);
            let counter = 0;
            if (data.share && data.share.share_count) {
                counter = data.share.share_count;
            }
            counter = counter > min_value ? counter : min_value;

            for (let i = 0; i < elements.length; i++) {
                let element = elements[i];
                element.innerHTML = this.shorter_number_js(counter);
                element.parentNode.style.opacity = 1;
            }
        });
    },
    openShareBox: function (url, title, facebookAppId) {
        this.closeShareBox();
        let overlay = document.createElement('div');
        overlay.className = 'lightbox-overlay lightbox';
        overlay.style.height = window.innerHeight + 'px';
        this.addEvent(window, 'resize', function () {
            overlay.style.height = window.innerHeight + 'px';
        });
        let sharelinks = document.createElement('div');
        sharelinks.className = 'share-links lightbox';
        sharelinks.innerHTML = this.shareHtml(url, title, facebookAppId);
        let closeBtn = document.createElement('div');
        closeBtn.className = 'close-wrpper-round lightbox';
        closeBtn.innerHTML = '<div class="btn-close"></div>';
        this.addEvent(closeBtn, 'click', this.closeShareBox);
        document.body.appendChild(overlay);
        document.body.appendChild(sharelinks);
        overlay.appendChild(closeBtn);


    },
    closeShareBox: function () {
        // console.log(55);
        let nodes = document.querySelectorAll('.lightbox');
        for (let i = 0; i < nodes.length; i++) {
            let node = nodes[i];
            node.parentNode.removeChild(node);
        }
    },
    shareHtml: function (url, title, facebookAppId) {

        let smList = [
            {
                name: "facebook",
                propsCode: `data-param-app_id="${facebookAppId}" data-param-href="${url}" data-param-quote="${title}"`
            },
            {name: "gplus", propsCode: ``},
            {name: "linkedin", propsCode: ``},
            {name: "pinterest", propsCode: `data-param-description="${title}"`},
            {name: "twitter", propsCode: ``},
            {name: "whatsapp", propsCode: ``}
        ];

        let result = [];
        for (let i = 0; i < smList.length; i++) {
            let item = smList[i];

            result.push(`<amp-social-share 
                width="60px" 
                height="60px" 
                type="${item.name}" 
                data-param-text="${title}" 
                data-param-url="${url}"
                ${item.propsCode}
             ></amp-social-share>`);
        }

        return result.join(' ');
    },
    errorHtmlCode: ``,
    loadMorePagination: function (btn, url, parentNode, linkClickHandler, contentSelector) {
        btn.setAttribute('data-state', 'loading');
        url = this.addStrToUrl(url, this.config.AJAX_URL_PREFIX);
        let that = this;
        let callCounter = 0;

        function call(url) {
            that.ajax(
                url,
                (content) => {
                    var holder = document.createElement('div');
                    holder.innerHTML = content;
                    holder.innerHTML = holder.querySelector(contentSelector).innerHTML;
                    holder.className = 'paged';
                    if (holder.querySelector('.space-for-fixed-header')) {
                        holder.removeChild(holder.querySelector('.space-for-fixed-header'));
                    }
                    that.attachEventToLinks(holder.querySelectorAll('a'), linkClickHandler);
                    btn.className = 'hidden';
                    btn.setAttribute('data-state', 'dismissed');
                    parentNode.appendChild(holder);
                    parentNode.dispatchEvent(that.getEventByName('contentLoadedToSlide'));
                },
                (err) => {
                    console.log('Network error occurred, url failed is ' + url + ' Code is ' + err);
                    setTimeout(() => {
                        if (callCounter >= that.config.numberOfAttemptsToLoadPage) {
                            btn.setAttribute('data-state', 'default');
                            btn.innerHTML = btn.innerHTML + ' <div class="some-error">' + window.config.loadmore.errorMsg + '</div>';
                            return;
                        }
                        call(url);
                        callCounter++
                    }, 1000);
                }
            );
        }

        call(url);
    },
    runVideoOnNewSlides: function (slide) {
        let videoWrapper = slide.querySelector('.wpb_video_wrapper');
        if (videoWrapper) {
            let scripts = this.transormToScripts(videoWrapper.innerHTML);
            scripts.forEach(script => {
                videoWrapper.appendChild(script);
            });
        }

    },
    runEmbedOnNewSlide: function (slide) {
        if ((typeof(twttr) != 'undefined') && twttr.widgets && twttr.widgets.load) {
            twttr.widgets.load(slide);
        }
        let embedWrapper = slide.querySelector('.embed');
        if (embedWrapper) {
            let scripts = this.transormToScripts_v2(embedWrapper.innerHTML);
            scripts.forEach(script => {
                embedWrapper.appendChild(script);
            });
        }
    },
    transormToScripts: function (nodes) {
        var out = [];
        nodes = nodes.replace(/script\>[\s]+\<script/g, 'script><script');
        var div = document.createElement('div');
        div.innerHTML = nodes;
        var nodes = div.childNodes;

        for (var i = 0; i < nodes.length; i++) {
            var clone = nodeScriptClone(nodes[i]);
            if (typeof(clone) != 'undefined') out.push(clone);
        }

        function nodeScriptClone(node) {
            if (node.nodeName != 'SCRIPT') return;
            var script = document.createElement("script");
            script.text = node.innerHTML;
            if (node.attributes) {
                for (var i = node.attributes.length - 1; i >= 0; i--) {
                    script.setAttribute(node.attributes[i].name, node.attributes[i].value);
                }
            }
            return script;
        }

        return out;
    },
    transormToScripts_v2: function (nodes) {
        var out = [];
        nodes = nodes.replace(/script\>[\s]+\<script/g, 'script><script');
        var div = document.createElement('div');
        div.innerHTML = nodes;
        var nodes = div.querySelectorAll('script');

        for (var i = 0; i < nodes.length; i++) {
            var clone = nodeScriptClone(nodes[i]);
            if (typeof(clone) != 'undefined') out.push(clone);
        }

        function nodeScriptClone(node) {
            if (node.nodeName != 'SCRIPT') return;
            var script = document.createElement("script");
            script.text = node.innerHTML;
            if (node.attributes) {
                for (var i = node.attributes.length - 1; i >= 0; i--) {
                    script.setAttribute(node.attributes[i].name, node.attributes[i].value);
                }
            }
            return script;
        }

        return out;
    },
    showCrossInCorner: function (url) {
        let cross = document.getElementById('cross-in-corner');
        cross.href = url;
        this.addEvent(cross, 'click', function () {
            cross.style.opacity = 0;
        });
        cross.style.display = 'block';
        setTimeout(() => {
            cross.style.opacity = 1;
        }, 500);
    },
    hideCrossInCorner: function () {
        let cross = document.getElementById('cross-in-corner');
        cross.style.display = 'none';
        cross.style.opacity = 0;
    },
    updateAddThis: function (title) {
        let url = window.location.href.split("?")[0].replace(/\/[0-9]+\/$/, "/");
        title = title ? title : window.document.title;
        window.addthis_share = {url: url, title: document.title};

        //Hide counter because we can't refresh it
        document.querySelector(".at-share-dock-outer a.at4-count").style.display = 'none';
        //fix width of other share buttons
        let share_buttons = document.querySelectorAll(".at-share-dock-outer a.at-share-btn");
        let amount_of_buttons = share_buttons.length;
        let new_share_buttons_width = (100 / amount_of_buttons) + '%';
        for(let i = 0; i < share_buttons.length; i++){
            let share_button = share_buttons[i];
            share_button.style.width = new_share_buttons_width;
        }

        // console.log('updateAddThis', {url: url, title: title});
    },
    getViewportHeight: function () {
        let doc = window.document,
            body = doc.body,
            html = doc.documentElement;
        return Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);

    },
    urlsBeforeHashAreEquals: function (url1, url2) {
        return (this._getUrlBeforeHash(url1) === this._getUrlBeforeHash(url2));
    },
    getElementViewportOffset: function (element) {
        let that = this;
        let viewportOffset = element.getBoundingClientRect();
        return {
            top: viewportOffset.top - that.config.headerHeight,
            bottom: viewportOffset.bottom - that.config.headerHeight
        };
    },
    isFacebookApp: function() {
        let ua = navigator.userAgent || navigator.vendor || window.opera;
        return (ua.indexOf("FBAN") > -1) || (ua.indexOf("FBAV") > -1);
    },
    blockScrollingOfMainWindow: function(){
        this.addEvent(window, 'scroll', () => { window.scrollTo( 0, 0 ); });
        this.addEvent(window, 'resize', () => { window.scrollTo( 0, 0 ); });
        this.addEvent(window, 'orientationchange', () => { window.scrollTo( 0, 0 ); });
    },
    _getUrlBeforeHash: function (url) {
        return url.split('#')[0];
    }
};